import { Skeleton } from "@/components/ui/skeleton";

const CustomizeSkeleton = () => {
  return (
    <div className="container mx-auto px-4 pt-24 pb-32 lg:pb-16">
      <Skeleton className="h-4 w-16 mb-6" />

      <div className="text-center max-w-2xl mx-auto mb-10 space-y-3">
        <Skeleton className="h-4 w-40 mx-auto" />
        <Skeleton className="h-9 w-72 mx-auto" />
        <Skeleton className="h-4 w-80 mx-auto" />
      </div>

      <div className="grid lg:grid-cols-[1fr_340px] gap-8 max-w-5xl mx-auto items-start">
        <div className="space-y-4">
          <Skeleton className="h-24 w-full rounded-xl" />

          {[0, 1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              className="h-32 w-full rounded-xl opacity-0 animate-fade-up"
              style={{ animationDelay: `${(i + 1) * 100}ms` }}
            />
          ))}
        </div>

        <div className="hidden lg:block">
          <Skeleton className="h-64 w-full rounded-xl" />
        </div>
      </div>
    </div>
  );
};

export default CustomizeSkeleton;
